import React, { FC, ReactNode } from 'react'
import { Stack, Typography } from '@mui/material'

import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { PORTAL_TEXT } from '@/apps/latest/shared/styles/portalTypography'

// 空状態 (= レコード 0 件) 表示. Notion 流軽量 placeholder.
interface EmptyStateProps {
  icon?: ReactNode
  title: string
  hint?: string
  action?: ReactNode
}

export const EmptyState: FC<EmptyStateProps> = ({
  icon,
  title,
  hint,
  action,
}) => (
  <Stack
    alignItems="center"
    justifyContent="center"
    gap={1}
    sx={{ minHeight: 240, py: 6 }}
  >
    {icon && (
      <Stack
        sx={{
          color: colorTokens.overlay.placeholderIcon,
          '& > svg': { fontSize: 40 },
        }}
      >
        {icon}
      </Stack>
    )}
    <Typography sx={PORTAL_TEXT.empty}>{title}</Typography>
    {hint && <Typography sx={PORTAL_TEXT.emptyHint}>{hint}</Typography>}
    {action}
  </Stack>
)
